<template>
    <div>

        <vue-topprogress ref="loadingProgress"></vue-topprogress>

        <printable-document v-if="!loading" class="mx-auto" title="Load Confirmation">

            <b-row class="px-3">
                <b-col cols="6" class="border p-3">
                    <table class="lc-details">
                        <tr><td>Carrier: </td><td>{{ order.carrier ? order.carrier.name : null }}</td></tr>
                        <tr><td>Attention: </td><td>{{ order.carrier && order.carrier.carrier_contacts[0].contact ? order.carrier.carrier_contacts[0].contact.full_name : null }}</td></tr>
                        <tr><td>Rate: </td><td>{{ (+(order.rate) ? order.rate : null) }}</td></tr>
                        <tr><td>Carrier Ph. #: </td><td>{{ order.carrier && order.carrier.carrier_contacts[0].contact ? order.carrier.carrier_contacts[0].contact.phone : null }}</td></tr>
                    </table>
                </b-col>
                <b-col cols="6" class="border p-3">
                    <table class="lc-details">
                        <tr><td>Load #: </td><td>{{ order.number }}</td></tr>
                        <tr><td>Date: </td><td>{{ (new Date()) | moment('MMM D, YYYY') }}</td></tr>
                        <tr><td>Carrier Fax. #: </td><td>403-627-3553</td></tr>
                    </table>
                </b-col>
                <b-col cols="6" class="border p-3">
                    <table class="lc-details">
                        <tr><td>Pickup Date: </td><td><span v-if="scheduled">{{ scheduled.created_at | moment('MMM D, YYYY') }}</span></td></tr>
                        <tr><td>Shipper: </td><td>SuperForm Products</td></tr>
                        <tr><td>Street: </td><td>1065 Willow Street</td></tr>
                        <tr><td>City: </td><td>Pincher Creek</td></tr>
                        <tr><td>Province: </td><td>Alberta, Canada</td></tr>
                    </table>
                </b-col>
                <b-col cols="6" class="border p-3">
                    <table class="lc-details">
                        <tr><td>Shipper Ph. #: </td><td>403-627-3555</td></tr>
                        <tr><td>Contact: </td><td></td></tr>
                        <tr><td>Shipping Hours: </td><td class="text-danger font-weight-bold">8:00 am to 4:00 pm</td></tr>
                    </table>
                </b-col>
                <b-col cols="6" class="border p-3">
                    <table class="lc-details">
                        <tr><td>Delivery Date: </td><td><span v-if="scheduled">{{ scheduled.created_at | moment('MMM D, YYYY') }}</span></td></tr>
                        <tr><td>Receiver: </td><td>{{ order.customer ? order.customer.name : null }}</td></tr>
                        <tr><td>Street: </td><td>{{ drop && drop.location ? drop.location.street_address : null }}</td></tr>
                        <tr><td>City: </td><td>{{ drop && drop.location ? drop.location.city : null }}</td></tr>
                        <tr><td>Postal Code: </td><td>{{ drop && drop.location ? drop.location.postal : null }}</td></tr>
                        <tr><td>Province/State: </td><td>{{ drop && drop.location ? drop.location.region : null }}</td></tr>
                        <tr><td>Customs Broker: </td><td>Livingston</td></tr>
                    </table>
                </b-col>
                <b-col cols="6" class="border p-3">
                    <table class="lc-details">
                        <tr><td>Receiver Ph. #: </td><td>{{ drop && drop.contact ? drop.contact.phone : null }}</td></tr>
                        <tr><td>Contact: </td><td>{{ drop && drop.contact ? drop.contact.full_name : null }}</td></tr>
                        <tr><td>Receiving Hours: </td><td>Call Ahead To Arrange</td></tr>
                        <tr><td>Equipment: </td><td>53' Dry Van</td></tr>
                    </table>
                </b-col>
                <b-col cols="12" class="border p-3">
                    <table class="lc-details">
                        <tr><td>Loading Instructions: </td><td></td></tr>
                    </table>
                </b-col>
            </b-row>
            <b-row class="px-3">
                <b-col cols="6" v-if="add_drops.length">
                    <b-row>
                        <b-col cols="12" class="border p-3">
                            Additional Drops:
                        </b-col>
                        <b-col cols="12" class="border p-3" v-for="(add_drop, index) in add_drops">
                            <table class="lc-details">
                                <tr><td>Drop Number: </td><td>{{ index+2 }}</td></tr>
                                <tr><td>Delivery Date: </td><td>{{ scheduled.created_at | moment('MMM D, YYYY') }}</td></tr>
                                <tr><td>Receiver: </td><td>{{ order.customer ? order.customer.name : null }}</td></tr>
                                <tr><td>Street: </td><td>{{ add_drop && add_drop.location ? add_drop.location.street_address : null }}</td></tr>
                                <tr><td>City: </td><td>{{ add_drop && add_drop.location ? add_drop.location.city : null }}</td></tr>
                                <tr><td>Postal Code: </td><td>{{ add_drop && add_drop.location ? add_drop.location.postal : null }}</td></tr>
                                <tr><td>Province/State: </td><td>{{ add_drop && add_drop.location ? add_drop.location.region : null }}</td></tr>
                            </table>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col :cols="add_drops.length ? 6 : 12">
                    <b-row>
                        <b-col cols="12" class="border p-3">
                            Notes:
                        </b-col>
                        <b-col cols="12" class="border p-3 disclaimer">
                            *** All rates include loading/unloading charges, stop off charges, fuel purchases & any other accessories, unless otherwise noted. *** The following must accompany invoice for payment to be processed:
                            (1) Our 4 digit reference number provided above;
                            (2) Original signed bill of lading. *** Forward invoice, referencing SuperForm Products reference number and all required documents to:
                            SuperForm Products Ltd
                            Box 2696
                            Pincher Creek, AB
                            T0K 1W0
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12" class="mb-2 mt-3">Please review, sign date and fax</b-col>
                <b-col cols="2">Accepted: </b-col>
                <b-col cols="4 border-bottom">&nbsp;</b-col>
                <b-col cols="2">Date: </b-col>
                <b-col cols="4 border-bottom">&nbsp;</b-col>
            </b-row>

        </printable-document>
    </div>
</template>

<script>
  import PrintableDocument from "../../components/shared/PrintableDocument";
  import OrderRetrieve from "../../helpers/OrderRetrieve";
  import moment from "moment";
  import Table from "../../views/base/Table";

  export default {
      name: 'OrderLoadConfirmation',
      components: {Table, PrintableDocument},
      data () {
        return {
          loading: true,
          order_id: this.$route.params.order_id,
          order: null,
          earliest: null,
          scheduled: null,
          drop: null,
          add_drops: [],
          notes: [],
        }
      },
	  methods: {
        initDrops: function() {
          let drops = {};
          this.order.order_contacts.forEach((order_contact) => {
            if(order_contact.drop) {
              if(!drops[order_contact.drop]) {
                drops[order_contact.drop] = {};
              }
              drops[order_contact.drop].contact = order_contact.contact;
            }
          });
          this.order.order_locations.forEach((order_location) => {
            if(order_location.drop) {
              if(!drops[order_location.drop]) {
                drops[order_location.drop] = {};
              }
              drops[order_location.drop].location = order_location.location;
            }
          });

          this.order.order_notes.forEach((order_note) => {
            if(order_note.drop) {
              if(!drops[order_note.drop]) {
                drops[order_note.drop] = {};
              }
              drops[order_note.drop].note = order_note.note;
            } else {
              this.notes.push(order_note);
            }
          });
          for(let i in drops) {
            if(!this.drop) {
              this.drop = drops[i];
            } else {
              this.add_drops.push(drops[i]);
            }
          }
        },
        initStatuses: function() {
          let earliest_time = null;
          let earliest = null;
          this.order.order_status_logs.forEach((log) => {
            let temp = moment(log.created_at);
            if(!earliest) {
              earliest = log;
              earliest_time = temp;
            } else if(temp.diff(earliest_time) > 0) {
              earliest = log;
              earliest_time = temp;
            }
            if(log.order_status && log.order_status.name === 'Scheduled') {
                this.scheduled = log;
            }
          });
          this.earliest = earliest;
        },
        init: function() {
          this.$refs.loadingProgress.start();
          this.loading = true;
          let handler = new OrderRetrieve(+(this.order_id));
          return handler.fetch().then(() => {
            this.order = handler.populate();
            this.initDrops();
            this.initStatuses();
            this.$refs.loadingProgress.done();
            this.loading = false;
          });
        }
      },
      mounted() {
        this.init();
      },
      created() {
        this.loading = true;
      }
	}
</script>
<style>
    .w-20 {
        width: 20%;
    }
    .printable-document .disclaimer {
        font-size: 0.6em;
    }
    .printable-document .lc-details {
        width: 100%;
    }
    .printable-document .lc-details tr > td:last-child {
        border-bottom: 1px solid #dee2e6 !important;
    }
    .printable-document .col-6 .lc-details tr > td:first-child {
        width: 40%;
    }
    .printable-document .col-6 .lc-details tr > td:last-child {
        width: 60%;
    }
    .printable-document .col-12 .lc-details tr > td:first-child {
        width: 20%;
    }
    .printable-document .col-12 .lc-details tr > td:last-child {
        width: 80%;
    }
</style>